import React from 'react';

// from https://commons.wikimedia.org/wiki/File:Infobox_info_icon.svg
export const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 140 140">
    <g>
      <path d="m80 15c-35.88 0-65 29.12-65 65s29.12 65 65 65 65-29.12 65-65-29.12-65-65-65zm0 10c30.36 0 55 24.64 55 55s-24.64 55-55 55-55-24.64-55-55 24.64-55 55-55z" />
      <path d="m57.373 18.231a9.3834 9.1153 0 1 1 -18.767 0 9.3834 9.1153 0 1 1 18.767 0z" transform="matrix(1.1989 0 0 1.2342 21.214 28.75)" />
      <path d="m90.665 110.96c-0.069 2.73 1.211 3.5 4.327 3.82l5.008 0.1v5.12h-39.073v-5.12l5.503-0.1c3.291-0.1 4.082-1.38 4.327-3.82v-30.813c0.035-4.879-6.296-4.113-10.757-3.968v-5.074l30.665-1.105" />
    </g>
  </svg>
);

export const AddIcon = () => (
  <svg width="24" height="24" fillRule="evenodd" clipRule="evenodd" viewBox="5 -3 13 30">
    <path d="M11.5 0c6.347 0 11.5 5.153 11.5 11.5s-5.153 11.5-11.5 11.5-11.5-5.153-11.5-11.5 5.153-11.5 11.5-11.5zm0 1c5.795 0 10.5 4.705 10.5 10.5s-4.705 10.5-10.5 10.5-10.5-4.705-10.5-10.5 4.705-10.5 10.5-10.5zm.5 10h6v1h-6v6h-1v-6h-6v-1h6v-6h1v6z" />
  </svg>
);


export const EditIcon = () => (
  <svg viewBox="-3 -2 24 24">
    <g stroke="" strokeWidth=".7">
      <path d="M15.6456959,0 C14.7524094,0 13.9132735,0.34700064 13.2811865,0.979482906 L1.02368702,13.2381095 C0.958396631,13.3033584 0.917590848,13.391592 0.901267775,13.4827999 L0.00649975048,18.4639228 C-0.0194682566,18.6092489 0.0339511552,18.7634697 0.138563932,18.8687601 C0.223886841,18.9540287 0.33962985,19 0.459080403,19 C0.48504841,19 0.507306973,18.9955513 0.534015729,18.9911024 L5.51830801,18.0961631 C5.60882376,18.0798508 5.68821118,18.0390706 5.75350537,17.9738217 L18.0110049,5.71519506 C18.6431298,5.08273178 19,4.24561006 19,3.35218923 C19,2.45799016 18.6431298,1.61122584 18.0110049,0.979502837 C17.3788799,0.347039552 16.5397441,1.99305657e-05 15.6457358,1.99305657e-05 L15.6456959,0 Z M15.6456959,0.903841664 C16.2978591,0.903841664 16.9188538,1.15815568 17.3795998,1.61934897 C17.8410865,2.08054226 18.0955623,2.69966156 18.0955623,3.35215032 C18.0955623,4.0038988 17.8410865,4.61411578 17.3795998,5.07456879 L17.0026914,5.4512375 C16.9826589,5.41490503 16.9581743,5.37857445 16.9270134,5.3481737 L13.6483436,2.07158869 C13.6164401,2.03896521 13.5830532,2.0167208 13.5452142,1.99595884 L13.9221226,1.61929013 C14.3828686,1.15809684 14.9934738,0.903782821 15.645637,0.903782821 L15.6456959,0.903841664 Z M12.9324646,2.6077342 C12.9532379,2.6462894 12.9762391,2.67965697 13.0081426,2.71154018 L16.2868124,5.98812518 C16.3187159,6.02000839 16.3521028,6.04299308 16.3906844,6.06375503 L5.26387206,17.1834922 C5.24383955,17.1479019 5.21787154,17.1093467 5.18819409,17.0796862 L1.91921099,13.8031012 C1.88953354,13.7734426 1.85021116,13.7571299 1.81534086,13.7371101 L12.9324646,2.6077342 Z M1.58893563,14.7536108 L4.245756,17.4087417 L1.01457011,17.9833684 L1.58893563,14.7536108 Z" id="Shape" />
    </g>
  </svg>
);

export const AvatarIcon = () => (
  <svg viewBox="0 0 485.211 485.21">
    <g>
      <path d="M394.235,333.585h-30.327c-33.495,0-60.653-27.158-60.653-60.654v-19.484c13.418-15.948,23.042-34.812,29.024-54.745c0.621-3.36,3.855-5.02,6.012-7.33c11.611-11.609,13.894-31.2,5.185-45.149c-1.186-2.117-3.322-3.953-3.201-6.576c0-17.784,0.089-35.596-0.023-53.366c-0.476-21.455-6.608-43.773-21.65-59.66c-12.144-12.836-28.819-20.479-46.022-23.75c-21.739-4.147-44.482-3.937-66.013,1.54c-18.659,4.709-36.189,15.637-47.028,31.836c-9.598,14.083-13.803,31.183-14.513,48.036c-0.266,18.094-0.061,36.233-0.116,54.371c0.413,3.631-2.667,6.088-4.058,9.094c-8.203,14.881-4.592,35.155,8.589,45.978c3.344,2.308,3.97,6.515,5.181,10.142c5.748,17.917,15.282,34.487,27.335,48.925v20.138c0,33.496-27.157,60.654-60.651,60.654H90.978c0,0-54.964,15.158-90.978,90.975v30.327c0,16.759,13.564,30.321,30.327,30.321h424.562 c16.759,0,30.322-13.562,30.322-30.321V424.56C449.199,348.749,394.235,333.585,394.235,333.585z" />
    </g>
  </svg>
);

export const UnblockIcon = () => (
  <svg viewBox="0 0 512 512">
    <g>
      <g>
        <path d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.331,26.629,74.98,74.98C26.628,123.332,0,187.62,0,256
          s26.628,132.667,74.98,181.019C123.332,485.371,187.619,512,256,512c68.38,0,132.667-26.629,181.019-74.981
          C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30
          s226,101.383,226,226S380.617,482,256,482z"
        />
      </g>
    </g>
    <g>
      <g>
        <path d="M378.305,173.859c-5.857-5.856-15.355-5.856-21.212,0.001L224.634,306.319l-69.727-69.727
          c-5.857-5.857-15.355-5.857-21.213,0c-5.858,5.857-5.858,15.355,0,21.213l80.333,80.333c2.929,2.929,6.768,4.393,10.606,4.393
          c3.838,0,7.678-1.465,10.606-4.393l143.066-143.066C384.163,189.215,384.163,179.717,378.305,173.859z"
        />
      </g>
    </g>
  </svg>
);

export const TeamIcon = () => (
  <svg viewBox="0 0 487.3 487.3">
    <g>
      <path d="M362.1,326.05c-32.6-26.8-67.7-44.5-74.9-48c-0.8-0.4-1.3-1.2-1.3-2.1v-50.7c6.4-4.3,10.6-11.5,10.6-19.7v-52.6c0-26.2-21.2-47.4-47.4-47.4h-5.6h-5.7c-26.2,0-47.4,21.2-47.4,47.4v52.6c0,8.2,4.2,15.5,10.6,19.7v50.7c0,0.9-0.5,1.7-1.3,2.1c-7.2,3.5-42.3,21.3-74.9,48c-5.9,4.8-9.3,12.1-9.3,19.7v36h128h127.9v-36C371.4,338.15,368,330.85,362.1,326.05z" />
    </g>
    <g>
      <path d="M479.2,290.55c-27.3-22.5-56.8-37.4-62.8-40.3c-0.7-0.3-1.1-1-1.1-1.8v-42.5c5.3-3.6,8.9-9.6,8.9-16.6v-44.1c0-21.9-17.8-39.7-39.7-39.7h-4.7h-4.7c-21.9,0-39.7,17.8-39.7,39.7v44.1c0,6.9,3.5,13,8.9,16.6v42.5c0,0.8-0.4,1.4-1.1,1.8c-3.7,1.8-16.5,8.2-32.1,18.2c15.6,8.6,40.3,23.4,63.6,42.6c8.2,6.7,13.6,16,15.6,26.2h97v-30.2C487,300.65,484.2,294.55,479.2,290.55z" />
    </g>
    <g>
      <path d="M144,250.25c-0.7-0.3-1.1-1-1.1-1.8v-42.5c5.3-3.6,8.9-9.6,8.9-16.6v-44.1c0-21.9-17.8-39.7-39.7-39.7h-4.7h-4.9c-21.9,0-39.7,17.8-39.7,39.7v44.1c0,6.9,3.5,13,8.9,16.6v42.5c0,0.8-0.4,1.4-1.1,1.8c-6,2.9-35.5,17.8-62.8,40.3c-4.9,4.1-7.8,10.1-7.8,16.5v30.2h97c1.9-10.2,7.4-19.5,15.6-26.2c23.3-19.2,48-34,63.6-42.6C160.5,258.45,147.7,252.05,144,250.25z" />
    </g>
  </svg>
);

export const InviteIcon = () => (
  <svg viewBox="0 0 472.811 472.811">
    <g>
      <path d="M358.75,0H114.061C97.555,0,84.128,13.428,84.128,29.934v412.944c0,16.505,13.428,29.934,29.934,29.934H358.75   c16.506,0,29.934-13.428,29.934-29.934V29.934C388.683,13.428,375.256,0,358.75,0z M99.128,75.236h274.556v312.687H99.128V75.236z    M114.061,15H358.75c8.234,0,14.934,6.699,14.934,14.934v35.302H99.128V29.934C99.128,21.699,105.827,15,114.061,15z    M358.75,457.811H114.061c-8.234,0-14.934-6.699-14.934-14.934v-44.955h274.556v44.955   C373.683,451.112,366.984,457.811,358.75,457.811z" />
      <path d="m236.406,404.552c-13.545,0-24.564,11.02-24.564,24.565s11.02,24.564 24.564,24.564 24.564-11.02 24.564-24.564-11.019-24.565-24.564-24.565zm0,39.129c-8.031,0-14.564-6.534-14.564-14.564 0-8.031 6.533-14.565 14.564-14.565s14.564,6.534 14.564,14.565c0,8.03-6.533,14.564-14.564,14.564z" />
      <path d="m202.406,47.645h68c2.762,0 5-2.239 5-5s-2.238-5-5-5h-68c-2.762,0-5,2.239-5,5s2.238,5 5,5z" />
      <path d="m184.409,47.645c1.31,0 2.6-0.53 3.53-1.46 0.93-0.94 1.47-2.22 1.47-3.54s-0.54-2.6-1.47-3.54c-0.931-0.93-2.221-1.46-3.53-1.46-1.32,0-2.601,0.53-3.54,1.46-0.93,0.93-1.46,2.22-1.46,3.54s0.53,2.6 1.46,3.54c0.93,0.93 2.22,1.46 3.54,1.46z" />
    </g>
  </svg>
);


export const DangerIcon = () => (
  <svg viewBox="0 0 26 22">
    <g>
      <g>
        <mask id="b" fill="#fff">
          <path id="a" d="M0 .16h25.048V22H0z" />
        </mask>
        <path fill="#EE3B35" d="M12.525 22H1.243C.287 22-.31 20.958.168 20.125l5.641-9.842L11.156.955a1.573 1.573 0 0 1 2.736 0l5.348 9.328 5.64 9.842c.478.833-.119 1.875-1.074 1.875H12.525z" mask="url(#b)" />
      </g>
      <path fill="#FFF" d="M13.44 14.336h-.904l-.484-4.519V7h1.885v2.817l-.498 4.52zM12 18h2v-2.26h-2V18z" />
    </g>
  </svg>
);

export const WarningIcon = () => (
  <svg className="warning-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 18">
    <g fill="none" fillRule="evenodd">
      <path d="M-.5-3h22v22h-22z" />
      <path fill="#FFF" d="M10.498.75a2.13 2.13 0 0 1 1.793.945l4.097 6.223 4.097 6.223a1.966 1.966 0 0 1 0 2.164 2.13 2.13 0 0 1-1.793.945H2.304a2.13 2.13 0 0 1-1.792-.945 1.966 1.966 0 0 1 0-2.164L4.61 7.918l4.097-6.223A2.13 2.13 0 0 1 10.498.75zm0 1.375a.768.768 0 0 0-.643.326L5.758 8.674 1.66 14.897a.583.583 0 0 0 0 .652.768.768 0 0 0 .643.326h16.388a.768.768 0 0 0 .644-.326.583.583 0 0 0 0-.652L15.24 8.674l-4.097-6.223a.768.768 0 0 0-.644-.326zm0 12.49a.802.802 0 1 1 0-1.605.802.802 0 0 1 0 1.605zm0-2.407a.688.688 0 0 1-.687-.687V5.104a.688.688 0 0 1 1.375 0v6.417c0 .38-.308.687-.688.687z" />
    </g>
  </svg>
);

export const SuccessIcon = () => (
  <svg className="success-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
    <g fill="none" fillRule="evenodd">
      <path fill="#00ce9d" d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm0 20.625c5.307 0 9.625-4.318 9.625-9.625S16.307 1.375 11 1.375 1.375 5.693 1.375 11 5.693 20.625 11 20.625zm2.912-12.97a.688.688 0 0 1 1.051.885l-4.889 5.805a.686.686 0 0 1-.968.084c-.012-.01-.021-.023-.032-.034l-.012-.006-2.902-2.903a.687.687 0 1 1 .972-.972l2.373 2.373 4.407-5.233z" />
    </g>
  </svg>
);


export const DownloadIcon = () => (
  <svg viewBox="0 0 227 198" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g
      id="Download-Icon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="icons/sm/import-2" fill="#2B73C7">
        <g id="icons/sm/import">
          <g id="Group-24" transform="translate(-0.000323, -0.000000)">
            <path
              d="M226.710493,112.788841 L226.710493,193.844934 C226.710493,197.354124 226.710493,197.354124 220.002164,197.354124 L5.79712342,197.354124 C0.00100094323,197.354124 0.00100094323,197.354124 0.00100094323,193.844934 L0.00100094323,110.127186 C0.00100094323,108.734928 2.46195791,103.583165 8.08082445,103.4965 C13.699691,103.409835 16.6456347,107.334401 16.6456347,110.127186 L16.6456347,112.788841 L16.6456347,182.570937 L209.272704,182.570937 C209.272704,140.337045 209.272704,117.076346 209.272704,112.788841 C209.272704,106.357583 214.284631,103.4965 217.799694,103.4965 C220.750483,103.4965 226.710493,106.357583 226.710493,112.788841 Z"
              id="Fill-4"
            />
            <rect
              id="Rectangle"
              x="104.636513"
              y="0"
              width="17.4393651"
              height="146.953846"
            />
            <path
              d="M156.954608,126.175807 L139.515243,144.545038 L139.515243,126.175807 L156.954608,126.175807 Z M139.515243,71.0681151 L156.954608,52.6988844 L156.954608,144.545038 L69.7577831,144.545038 L87.1971481,126.175807 L139.515243,126.175807 L139.515243,71.0681151 Z M156.954608,126.175807 L139.515243,144.545038 L139.515243,126.175807 L156.954608,126.175807 Z M139.515243,71.0681151 L156.954608,52.6988844 L156.954608,144.545038 L69.7577831,144.545038 L87.1971481,126.175807 L139.515243,126.175807 L139.515243,71.0681151 Z"
              id="Rectangle"
              fillRule="nonzero"
              transform="translate(113.356196, 98.621961) rotate(45.000000) translate(-113.356196, -98.621961) "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export { default as ArrowIcon } from './arrow';
export { default as FillArrowIcon } from './fillArrow';
export { default as BlockIcon } from './block';
export { default as CalendarIcon } from './calendar';
export { default as CheckIcon } from './check';
export { default as CloseIcon } from './close';
export { default as ClockIcon } from './clock';
export { default as DeleteIcon } from './delete';
export { default as EmailIcon } from './email';
export { default as GlobeIcon } from './globe';
export { default as PhoneIcon } from './phone';
export { default as SlotsIcon } from './slots';
export { default as BubbleIcon } from './bubble';
export { FilledStar, EmptyStar } from './star';
export { default as CameraIcon } from './camera';
export { default as DetailsIcon } from './details';
export { default as AdjustIcon } from './adjust';
export { default as AbsentIcon } from './absent';
export { default as LightbulbIcon } from './lightbulb';
export { default as PaperIcon } from './paper';
export { default as CustomizeReportIcon } from './customizeReport';
export { default as DocumentSearchIcon } from './documentSearch';
export { default as CircularWarningIcon } from './circularWarning';
export { default as UserIcon } from './user';
export { default as W2BadgeIcon } from './w2Badge';
